// 请假相关接口
import request from '@/api/request'

// 进行补请假
export function repairUserLeave(data: any) {
    let url = '/api/manager/userleave/repair';
    return request({
        url: url,
        method: 'post',
        data
    })
}